import rootAPIs from '@/api/rootAPIs';


export default {
  /**
   * Get the CMS text from the CMS API and add it to the state.
   *
   * @param {function} commit - The commit function for module mutations
   * @param {string} cmsHost - The URL to get the CMS text from
   */
  updateText({ commit }, { utilityID }) {
    return rootAPIs.retrieveMarketplaceText(utilityID).then(data => commit('setText', { cmsText: data }));
  },
};
